const ENVIRONMENTS = {
  DEV: {
    name: 'DEV',
    urlBase: 'http://localhost:7000/api/'
  },
  PAL: {
    name: 'PAL',
    urlBase: 'https://core-palmicultor.palmaceite.com/api/'
  },
  MUL: {
    name: 'MUL',
    urlBase: 'https://core.palmicultor.com.co/api/'
  }
};

// Cambia esta línea según el entorno
const CURRENT_ENVIRONMENT = 'MUL'; //DEV o 'PAL' o 'MUL'

export const URL_BASE = ENVIRONMENTS[CURRENT_ENVIRONMENT].urlBase;
export const ENVIRONMENT = ENVIRONMENTS[CURRENT_ENVIRONMENT].name;